(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alleon-recommendations"] && !Shopify.designMode) return;
  try {
    
function alleonRecommend(source,catalog,filters,limit) {
const tag=(p,prefix)=>p.tags.find(t=>t.startsWith(prefix))||'';
const world=tag(source,'world_'),audience=tag(source,'audience_'),line=tag(source,'line_');
const type=p=>{const h=p.handle;for(const [pattern,value] of [[/active-set/,'set'],[/dress/,'dress'],[/legging/,'leggings'],[/sports-bra/,'sports bra'],[/planter/,'planter'],[/tray/,'tray'],[/frame/,'frame'],[/organizer|pencil-holder/,'organizer'],[/skirt/,'skirt'],[/pants|trouser/,'pants'],[/blazer|jacket/,'jacket'],[/shirt/,'shirt'],[/top/,'top']])if(pattern.test(h))return value;return p.type.toLowerCase();};
const links={shirt:['pants','skirt','jacket'],top:['pants','skirt','jacket'],pants:['shirt','top','jacket'],skirt:['shirt','top','jacket'],dress:['jacket'],jacket:['shirt','top','pants','skirt','dress']};
const sourceType=type(source);
const result={look:[],similar:[]};
for(const p of catalog){
if(p.id===source.id||tag(p,'world_')!==world)continue;
if(world!=='world_home'&&tag(p,'audience_')!==audience)continue;
const available=p.variants.filter(v=>v.available&&(!filters.size||v.size===filters.size)&&(!filters.color||v.color===filters.color)&&v.price<=filters.budget);
if(!available.length)continue;
available.sort((a,b)=>Number(b.color===filters.preferredColor)-Number(a.color===filters.preferredColor)||Math.abs(a.price-source.price)-Math.abs(b.price-source.price));
const variant=available[0];
const sameType=type(p)===sourceType;
let pair=false;
if(world==='world_fashion')pair=(links[sourceType]||[]).includes(type(p));
if(world==='world_home')pair=!!line&&tag(p,'line_')===line&&!sameType;
if(world==='world_active'){
const h=source.handle,ph=p.handle;
const color=['blue','red','yellow'].find(c=>h.includes(c));
const sourcePrint=h.includes('print');
if(sourcePrint&&sourceType==='leggings')pair=['top','sports bra'].includes(type(p))&&ph.includes('white')&&!ph.includes('print');
else if(sourcePrint&&['top','sports bra'].includes(sourceType))pair=type(p)==='leggings'&&!!color&&ph.includes(color)&&!ph.includes('print');
}
const score=(variant.color===filters.preferredColor?40:0)+(line&&tag(p,'line_')===line?25:0)-Math.abs(variant.price-source.price)/100;
const entry={product:p,variant,score,reason:world==='world_home'?'line':'pair'};
if(pair)result.look.push(entry);
else if(sameType)result.similar.push({...entry,reason:'alternative'});
}
for(const key of ['look','similar'])result[key].sort((a,b)=>b.score-a.score||a.product.handle.localeCompare(b.product.handle));
return {look:result.look.slice(0,limit),similar:result.similar.slice(0,limit)};
}

if(!customElements.get('alleon-recommendations')){
class AlleonRecommendations extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.data=JSON.parse(this.querySelector('[data-catalog]').textContent);
this.s=JSON.parse(this.querySelector('[data-strings]').textContent);
this.controls=Object.fromEntries([...this.querySelectorAll('[data-filter]')].map(e=>[e.dataset.filter,e]));
const products=this.data.products;
const sizes=[...new Set(products.flatMap(p=>p.variants.filter(v=>v.available).map(v=>v.size)).filter(Boolean))];
sizes.sort((a,b)=>['XS','S','M','L','XL','XXL'].indexOf(a)-['XS','S','M','L','XL','XXL'].indexOf(b));
const colors=[...new Set(products.flatMap(p=>p.variants.filter(v=>v.available).map(v=>v.color)).filter(Boolean))].sort();
for(const [key,vals] of [['size',sizes],['color',colors]]){for(const value of vals){const o=document.createElement('option');o.value=value;o.textContent=value;this.controls[key].append(o);}this.controls[key].closest('label').hidden=!vals.length;}
this.querySelector('[data-apply]').addEventListener('click',()=>this.render(true));
this.querySelector('[data-reset]').addEventListener('click',()=>{Object.values(this.controls).forEach(e=>e.value='');this.render(true);});
this.addEventListener('keydown',e=>{if(e.key==='Enter'&&e.target.tagName==='INPUT'){e.preventDefault();this.render(true);}});
this.querySelector('[data-interface]').hidden=false;
this.render(false);
}
render(announce){
const budgetText=this.controls.budget.value.trim().replace(',','.');
const budget=budgetText?Number(budgetText)*100:Infinity;
const status=this.querySelector('[data-status]');
if(!Number.isFinite(budget)&&budget!==Infinity||budget<=0||budgetText&&!/^\d+([.]\d{1,2})?$/.test(budgetText)){status.textContent=this.s.invalid;this.controls.budget.setAttribute('aria-invalid','true');this.controls.budget.focus();return;}
this.controls.budget.removeAttribute('aria-invalid');
const result=alleonRecommend(this.data.source,this.data.products,{size:this.controls.size.value,color:this.controls.color.value,budget,preferredColor:this.controls.color.value||this.data.source.color},Number(this.dataset.limit));
for(const key of ['look','similar']){
const group=this.querySelector('[data-group="'+key+'"]'),list=group.querySelector('[data-cards]');list.replaceChildren();
group.hidden=!result[key].length;
for(const item of result[key])list.append(this.card(item));
}
this.querySelector('[data-empty]').hidden=!!(result.look.length+result.similar.length);
status.textContent=announce?this.s.results+' · '+(result.look.length+result.similar.length):'';
}
card({product:p,variant:v,reason}){
const li=document.createElement('li');li.className='alleon-rec__card';
const a=document.createElement('a');a.href=p.url+'?variant='+v.id;
const img=document.createElement('img');img.src=v.image||p.image;img.alt=p.title;img.loading='lazy';img.width=600;img.height=800;
const title=document.createElement('h3');title.textContent=p.title;
a.append(img,title);li.append(a);
const add=(text,cls)=>{const el=document.createElement('p');el.textContent=text;if(cls)el.className=cls;li.append(el);};
add(v.money,'alleon-rec__price');add(this.s[reason],'alleon-rec__reason');
add([v.size,v.color].filter(Boolean).join(' · '));
add(this.s[p.preorder?'preorder':'available'],'alleon-rec__badge');
const link=document.createElement('a');link.href=a.href;link.className='alleon-rec__link';link.textContent=this.s.view;li.append(link);
return li;
}}
customElements.define('alleon-recommendations',AlleonRecommendations);
}

  } catch(e) { console.error(e); }
})();
})();
